export const helloWorldProgram = `fn main() -> int
{
    println("Hello world")
    return 0
}
`;
export default helloWorldProgram;
